//###########################################################
//React & React Hooks
import React, { useEffect, useRef, useState } from "react";


//###########################################################
//Layout & Core Components
import BaseLayout from "../../components/layout/BaseLayout";
import Button from "../../components/custom/Button";
import AutoResizableTextarea from "../../components/AutoResizableTextarea";
import Modal from "../../components/Modal";
import Integration from "../../components/Integration";
import PremiumFeatures from "../../components/premiumFeatureComponent/comp (2)";


//###########################################################
//Email Dialog Components
import EmailLabels from "../../components/dialog/EmailLabels";
import EmailSorting from "../../components/dialog/EmailSorting";
import EmailComponent from "../../components/dialog/EmailModal";
import EmailSearch from "../../components/dialog/EmailSearch";
import ComposeEmail from "../../components/dialog/ComposeEmail";
import NoMailScreen from "../../components/dialog/NoMailScreen";
import MailBoxesIntegration from "../../components/dialog/MailBoxesIntegration";

//###########################################################
//Event Components
import CombinedFeedback from "../../components/meeting/CombinedFeedback";
import CalendarEventEditor from "../../components/meeting/CalendarEventEditor";

//###########################################################
//Form & Trigger Components
import QuestionForm from "../../components/form/QuestionForm";
import SelectedTriggerItem from "../../components/form/SelectedTriggerItem";
import TriggerModal from "../../components/form/TriggerModal";

//###########################################################
//Utility Functions & Hooks
import { taskDateFormat } from "../../utils/helper";
import {
  dataSources,
  dialogueData,
  integrationData,
  meetingFeedbackData,
} from "../../utils/constants";

//###########################################################
//API Services
import { createTempBot, getOutlookEmailsFromDB, getAuthenticatedApps } from "../../services/api";

//###########################################################
//Context Providers
import { DataState } from "../../context/DataProvider";
import { useEmails } from "../../context/EmailsProvider";

//###########################################################
//Toast
import { toast } from "react-hot-toast";

//###########################################################
//Timeline
import Timeline from "../../components/dialog/Timeline";

//###########################################################
//Icons
import { FaSearch, FaAngleLeft, FaAngleRight, FaFilter } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { PiDotsThreeOutlineVerticalFill, PiSortAscendingBold } from "react-icons/pi";
import { IoIosArrowDown } from "react-icons/io";
import {
  FiMail,
  FiClock,
  FiArchive,
  FiTrash2,
  FiArrowRightCircle,
  FiLink,
} from "react-icons/fi";
import { RiMailAddFill } from "react-icons/ri";
import { FaFilter as FaFilter6 } from "react-icons/fa6";
import { TiThMenu } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import useClickOutside from "../../hooks/useClickOutside";
import OqlousCTA from "../../components/Logo";



//###########################################################




const analyticsData = {
  snippet:
    "This email is an application for the Python Developer Intern position. The applicant highlights their experience with Python, Flask, MongoDB, and AWS.",
  priority: "High",
  insights:
    "The email demonstrates strong alignment with the job requirements and showcases relevant technical skills.",
};

function getSenderNameOrEmail(fromString) {
  // Check if the string contains a sender name
  if (fromString.includes("<")) {
    // Extract the part before `<` (the name)
    return fromString.split("<")[0].trim();
  } else {
    // If no `<`, return the full email
    return fromString.trim();
  }
}

function getDayAndMonth(dateString) {
  // Convert to Date object
  const date = new Date(dateString);
  // Format day and month
  const day = date.getDate(); // Day of the month
  const month = date.toLocaleString("en-IN", { month: "short" }); // Short month name
  return `${day} ${month}`;
}
function getDayMonthAndISTTime(dateString) {
  // Convert to Date object
  const date = new Date(dateString);

  // Convert to IST (UTC+5:30)
  const options = { timeZone: "Asia/Kolkata", hour: "numeric", minute: "numeric", hour12: true };
  const istTime = new Intl.DateTimeFormat("en-IN", options).format(date);

  // Format day and month
  const day = date.getDate(); // Day of the month
  const month = date.toLocaleString("en-IN", { month: "short" }); // Short month name

  return `${istTime}, ${day} ${month}`;
}

const convertOutlookToUniformFormat = (outlookEmailList) => {
  return outlookEmailList.map((outlookMail) => {
    return {
      ...outlookMail,
      snippet: outlookMail.bodyPreview,
      // priority: outlookMail.importance,
    };
  });
};

const EmailList = ({
  emailList,
  totalEmails,
  currentPage,
  setCurrentPage,
  loadingEmails,
  emailsPerPage,
  isOutlook = false,
  setSelectedEmail,
  emailfilter,
  handleFilterChange,
  isGmailSynchronized,
  isOutlookSynchronized

}) => {

  useEffect(() => {
    console.log("isGmailSynchronized", isGmailSynchronized);
    console.log("isOutlookSynchronized", isOutlookSynchronized);

    if (!isGmailSynchronized) {
      console.log("no mail screen condition");
    }
  }, [isGmailSynchronized, isOutlookSynchronized]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const uniformEmailList = isOutlook
    ? convertOutlookToUniformFormat(emailList)
    : emailList;

  if ((isOutlook && !isOutlookSynchronized) || (!isOutlook && !isGmailSynchronized)) {
    return (
      <div className="flex flex-col flex-1 w-full h-full gap-2">
        <div className="flex flex-col items-center w-full h-full mx-auto overflow-hidden ">
          <NoMailScreen isOutlook={isOutlook} isGmailSynchronized={isGmailSynchronized} isOutlookSynchronized={isOutlookSynchronized} />
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col flex-1 w-full gap-2">
      <div className="flex flex-col items-center w-full h-full mx-auto overflow-hidden">

        {/* TABLE VIEW FOR DESKTOP */}
        <div className="hidden w-full overflow-x-auto overflow-y-auto border shadow-md md:block border-zinc-700 scrollbar-none rounded-b-xl bg-zinc-900 text-zinc-100">
          <table className="min-w-full border-collapse divide-y rounded-b-lg divide-zinc-700">
            <thead>
              <tr className="bg-zinc-800">
                {["Sender", "Snippet", "Time", "Priority"].map((heading) => (
                  <th key={heading} className="px-3 py-2 text-sm font-medium text-left text-zinc-400">
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-700">
              {loadingEmails ? (
                Array.from({ length: emailsPerPage || 10 }).map((_, index) => (
                  <tr key={index} className="animate-pulse">
                    <td className="px-3 py-2"><div className="h-6 bg-gray-800 rounded w-36"></div></td>
                    <td className="px-3 py-2"><div className="h-6 w-[450px] bg-gray-800 rounded"></div></td>
                    <td className="px-3 py-2"><div className="w-16 h-6 bg-gray-800 rounded"></div></td>
                    <td className="px-3 py-2"><div className="w-12 h-6 bg-gray-800 rounded"></div></td>
                  </tr>
                ))
              ) : emailList?.length === 0 ? (
                <tr>
                  <td colSpan="4" className="py-4 text-center text-gray-500">No Emails Found</td>
                </tr>
              ) : (
                uniformEmailList.map((email, index) => {
                  const senderName = email.from?.name;
                  const subject = email?.subject || "";
                  const snippet = email?.snippet || "";
                  const displaySnippet =
                    subject.length >= 100
                      ? subject.slice(0, 100)
                      : `${subject} ${snippet.slice(0, 100 - subject.length)}`.trim() + "...";

                  return (
                    <tr
                      key={index}
                      className="cursor-pointer hover:bg-zinc-800"
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => setSelectedEmail(email)}
                    >
                      <td className={`px-3 py-2 text-sm whitespace-nowrap flex items-center ${!email.isRead ? "font-bold" : "text-gray-300"}`}>
                        <FiMail className="mr-2 text-[#5652CF]" />
                        {senderName?.length > 20 ? `${senderName.slice(0, 20)}...` : senderName}
                      </td>
                      <td className={`px-3 py-2 text-sm text-zinc-400 ${!email.isRead ? "font-bold" : "font-semibold"}`}>
                        {displaySnippet}
                      </td>
                      <td className="px-3 py-2 text-sm text-zinc-500 whitespace-nowrap">
                        {hoveredRow === index ? (
                          <div className="flex items-center space-x-2 font-semibold">
                            <FiArchive className="hover:text-zinc-400" size={15} />
                            <FiTrash2 className="hover:text-zinc-400" size={15} />
                            <FiArrowRightCircle className="hover:text-zinc-400" size={15} />
                          </div>
                        ) : (
                          <div className="flex items-center">
                            <FiClock className="mr-2 text-zinc-500" />
                            {getDayMonthAndISTTime(email.date)}
                          </div>
                        )}
                      </td>
                      <td className="flex items-center justify-center px-3 py-2 text-sm">
                        <span className={`px-2 py-[2px] w-5/6 flex items-center justify-center rounded-xl text-xs font-semibold text-white bg-opacity-80
                        ${email?.priority <= 1 ? "bg-[#5652CF]"
                            : email?.priority <= 3 ? "bg-yellow-500"
                              : "bg-red-500"}`}>
                          {email?.priority <= 1 ? "Low"
                            : email?.priority <= 3 ? "Medium"
                              : "High"}
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* CARD VIEW FOR MOBILE */}
        <div className="block w-full overflow-y-auto border divide-y md:hidden border-zinc-700 divide-zinc-700">
          {loadingEmails ? (
            Array.from({ length: 10 }).map((_, index) => (
              <div key={index} className="p-2 space-y-1 bg-zinc-900 animate-pulse">
                <div className="w-3/4 h-4 rounded bg-zinc-700"></div>
                <div className="flex items-center justify-between w-full gap-2">
                  <div className="w-1/2 h-3 rounded bg-zinc-800"></div>
                  <div className="w-10 h-3 rounded bg-zinc-700"></div>
                </div>
              </div>
            ))
          ) : uniformEmailList.length === 0 ? (
            <div className="py-4 text-center text-gray-500">No Emails Found</div>
          ) : (
            uniformEmailList.map((email, index) => (
              <div
                key={index}
                onClick={() => setSelectedEmail(email)}
                className="flex flex-col p-3 space-y-1 shadow-md cursor-pointer bg-zinc-900 hover:bg-zinc-800"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className={`text-[0.8rem] sm:text-sm font-semibold flex items-center gap-2  justify-center ${!email.isRead ? "text-white" : "text-zinc-300"}`}>
                    <FiMail className="mr-1 text-[#5652CF]" />
                    {email.from?.name?.slice(0, 25) || "Unknown"}
                  </span>
                  <span className="text-[0.6rem] sm:text-xs text-zinc-400 flex items-center">
                    <FiClock className="mr-1" />
                    {getDayMonthAndISTTime(email.date)}
                  </span>
                </div>
                <div className="flex justify-between gap-6" style={{ fontSize: "0.6rem" }}>
                  <div className="text-xs font-medium text-zinc-400" >
                    {email.subject || email.snippet}
                  </div>
                  <div className="">
                    <span className={`px-2 py-[2px] rounded-xl text-white font-semibold
                  ${email?.priority <= 1 ? "bg-[#5652CF]"
                        : email?.priority <= 3 ? "bg-yellow-500"
                          : "bg-red-500"}`}>
                      {email?.priority <= 1 ? "Low"
                        : email?.priority <= 3 ? "Medium"
                          : "High"}
                    </span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </div>

  );
};

const Leftbar = ({
  selectedTab,
  isAnalyticsView,
  emailStats,
  selectedEmail,
}) => {
  console.log("Left bar email Stats", emailStats);
  return (
    <div className="flex items-center justify-center h-full p-2">
      {/* {selectedTab === "mails" &&
        (isAnalyticsView ? (
          <Timeline />
        ) : (
          <EmailLabels emailStats={emailStats} />
        ))} */}

      {selectedTab === "mails" && selectedEmail && <Timeline />}
      {selectedTab === "history" && <div>history</div>}
      {selectedTab === "teams" && <div>teams</div>}
    </div>
  );
};

const CreateDialogueForm = ({ isModalOpen, closeModal }) => {
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [isDataSourceModalOpen, setIsDataSourceModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const {
    createAndHandleClarificationQuestions,
    setError,
    botCreationId,
    setBotCreationId,
    userGoogleId,
  } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(""); // State for storing the trigger name
  const [dialogueName, setDialogueName] = useState(""); // State for storing the instruction
  const [instruction, setInstruction] = useState(""); // State for storing the instruction

  useEffect(() => {
    if (isModalOpen) {
      const createBot = async () => {
        try {
          const response = await createTempBot({}, userGoogleId);
          if (response.error) {
            setError(JSON.stringify(response.error));
            console.log("Temp bot creation error:", response.error);
            return;
          }
          if (response.bot_id) {
            console.log("Created temp bot:", response.bot_id);
            setBotCreationId(response.bot_id);
          }
        } catch (err) {
          setError(JSON.stringify(err));
          console.log("Temp bot creation error:", err);
        }
      };
      createBot();
    }
  }, [isModalOpen]);

  const handleDeleteOption = (optionId) => {
    setSelectTrigerOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteDataSourceOption = (optionId) => {
    setSelectDataSourceOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleTriggerEditOption = (option) => {
    setEditOption(option);
    setIsTriggerModalOpen(true);
  };
  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };
  const handleDataSourceEditOption = (option) => {
    setEditOption(option);
    setIsDataSourceModalOpen(true);
  };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const clearStates = () => {
    setSelectTrigerOptions([]);
    setSelectIntegrationOptions([]);
    setSelectDataSourceOptions([]);
    setTriggerName("");
    setInstruction("");
  };
  const handleNewInstructionSubmission = async () => {
    setIsFormLoading(true);
    try {
      const final_response = await createAndHandleClarificationQuestions(
        instruction,
        triggerName,
        selectTrigerOptions,
        selectIntegrationOptions,
        selectDataSourceOptions
      );
      if (final_response && final_response.questions) {
        setShowQuestionForm(true);
      } else {
        console.log("No Questions Returned");
      }
    } catch (error) {
    } finally {
      setIsFormLoading(false);
    }
  };
  const handleShowTestScreen = () => {
    setShowTestScreen(true);
  };

  return (
    <div className="flex items-center justify-center duration-200">
      {!showTestScreen && !showQuestionForm && (
        <div className="w-full overflow-auto rounded-lg bg-2">
          <div className="flex flex-col gap-8 p-6">
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Name of the PM/Dialogue
                </h1>
              </div>
              <input
                value={dialogueName}
                onChange={(e) => setDialogueName(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none bg-2 br-1"
                placeholder=""
              />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Dialogue instructions
                </h1>
              </div>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none h-52 bg-2 br-1"
                placeholder="Instructions describe your workflow requirements in detail. Include all necessary steps, data processing instructions, and desired outcomes across integrated applications (e.g. Jira, Email, Sheets, Docs). Example: 'For every email received in the inbox, send an automated apology response explaining a 34 hour delay in support. Then, create a Jira task under the 'Support' Project, including the email content and tagging it as 'High Priority'. Notify the team lead in Slack once task is created."
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="p-2 text-sm transition-all duration-200 bg-1"
                >
                  <MdAdd />
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Data sources</h1>
                  <p className="text-sm">
                    Add data sources required in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsDataSourceModalOpen(true)}
                  className="p-2 text-sm transition-all duration-200 bg-1"
                >
                  <MdAdd />
                </button>
              </div>
              {selectDataSourceOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleDataSourceEditOption(item)}
                  handleDeleteOption={handleDeleteDataSourceOption}
                />
              ))}
            </div>

            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Continue
              </Button>
            </div>
            {botCreationId && (
              <TriggerModal
                title="Add integration"
                desc=" Select the app you’d like to add as integration."
                isOpen={isIntegrationModalOpen}
                onClose={() => {
                  setIsIntegrationModalOpen(false);
                  setEditOption(null);
                }}
                appsData={integrationData}
                selectedOptions={selectIntegrationOptions}
                setSelectedOptions={setSelectIntegrationOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}
            {botCreationId && (
              <TriggerModal
                title="Add data source"
                desc=" Select the app you’d like to add the data source from."
                isOpen={isDataSourceModalOpen}
                onClose={() => {
                  setIsDataSourceModalOpen(false);
                  setEditOption(null);
                }}
                appsData={dataSources}
                selectedOptions={selectDataSourceOptions}
                setSelectedOptions={setSelectDataSourceOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}
          </div>
        </div>
      )}
      {showQuestionForm && !showTestScreen && (
        <div className="bg-zinc-900 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 px-3 py-5 border-b border-zinc-800">
            <div className="px-3 py-1.5 bg-transparent text-xl font-bold flex items-center gap-3">
              <button
                onClick={() => setShowQuestionForm(false)}
                className="bg-2 transition-all duration-200 rounded-lg p-1.5"
              >
                <FaArrowLeftLong />
              </button>
              Clarification Questions
            </div>
            <div></div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <QuestionForm
              handleShowTestScreen={handleShowTestScreen}
              closeModal={closeModal}
              setShowQuestionForm={setShowQuestionForm}
              clearStates={clearStates}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const DialogueDetails = ({
  handleSelectTab,
  selectedTab,
  isAnalyticsView,
  setIsAnalyticsView,
  setEmailStats,
  emailStats,
  selectedEmail,
  setSelectedEmail,
  isComposeEmailModalOpen,
  setIsComposeEmailModalOpen
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [expandedTile, setExpandedTile] = useState(null); // State for expanded tile
  const { bots, userGoogleId } = DataState();
  const walletAddressRef = useRef(null);
  const [showIntegration, setShowIntegration] = useState(false);
  const {
    emails,
    setEmails,
    totalEmails,
    setTotalEmails,
    currentPage,
    setCurrentPage,
    emailfilter,
    setEmailFilter,
    loadingEmails,
    setLoadingEmails,
    originalEmailsOrder,
    setOriginalEmailsOrder,
    emailsPerPage,
    totalPages,
    isOutlook,
    setIsOutlook,
    isGmailAuthenticated,
    isOutlookAuthenticated,
    isGmailSynchronized,
    isOutlookSynchronized,

    newEmailCount,
    setNewEmailCount,
    priorities,
    setPriorities,
    seenMessageIdsRef
  } = useEmails();
  console.log("isOutlookAuthenticated", isOutlookAuthenticated);
  console.log("isGmailAuthenticated", isGmailAuthenticated);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [ismdFilterModalOpen, setIsmdFilterModalOpen] = useState(false);
  const [isSortingModalOpen, setIsSortingModalOpen] = useState(false);
  const [ismdSortingModalOpen, setIsmdSortingModalOpen] = useState(false);
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
  const [emailSorting, setEmailSorting] = useState("");
  const [meetingSubTab, setMeetingSubTab] = useState("completed");
  const [isAdvanceSearchOpen, setIsAdvancedSearchOpen] = useState(false);
  const [showPremium, setShowPremium] = useState(true);

  // ################ states for responsive design ################
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);



  const nextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));


  useEffect(() => {
    console.log("emails are after sorting:", emails);
  }, [emails]);


  useEffect(() => {
    console.log("emails are after sorting:", emails);
  }, [emails]);

  const toggleDropdown = (botId) => {
    setDropdownOpen((prev) => (prev === botId ? null : botId));
  };

  const toggleExpand = (id) => {
    setExpandedTile((prev) => (prev === id ? null : id));
  };

  useClickOutside([walletAddressRef], () => toggleDropdown(null));

  useEffect(() => {
    const handleClickOutside = () => setIsFilterModalOpen(false);

    if (isFilterModalOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isFilterModalOpen]);

  console.log("bots", bots);

  useEffect(() => {
    const handleClickOutside = () => setIsSortingModalOpen(false);

    if (isSortingModalOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isSortingModalOpen]);

  const handleFilterChange = (filterKey, value) => {
    setEmailFilter((prevFilter) => {
      const newFilter = { ...prevFilter };

      // If the filter is for Inbox or SentItems, remove the other
      if (filterKey === "Inbox" || filterKey === "SentItems") {
        const otherKey = filterKey === "Inbox" ? "SentItems" : "Inbox";
        delete newFilter[otherKey];
      }

      // Toggle the current filter
      if (newFilter[filterKey] === value) {
        delete newFilter[filterKey];
      } else {
        newFilter[filterKey] = value;
      }
      return newFilter;
    });
  };


  useEffect(() => {
    if (selectedTab === 'teams' || selectedTab === 'meeting') {
      setShowPremium(true);
      const timeout = setTimeout(() => {
        setShowPremium(false);
      }, 1000);

      return () => clearTimeout(timeout); // cleanup on unmount or tab change
    } else {
      setShowPremium(false); // no premium popup for other tabs
    }
  }, [selectedTab]);

  // calculating email notification badgeColor based on the highest priority 
  const highestPriority = priorities.length > 0 ? Math.max(...priorities) : null;
  const badgeColor = highestPriority === 0 || highestPriority === 1
    ? "bg-[#5652CF]"
    : highestPriority === 2 || highestPriority === 3
      ? "bg-yellow-500"
      : highestPriority >= 4
        ? "bg-red-600"
        : "bg-gray-500";



  return (
    <>

      {/* ################################################### Mail Boxes Integration Component START ###############################################  */}
      {showIntegration && (
        <Integration onClose={() => setShowIntegration(false)} user_google_id={userGoogleId} onlyEmailApps={true} />
      )}
      {/* ################################################### Mail Boxes Integration Component END ###############################################  */}


      <div className={` relative flex ${selectedTab === "mails" ? "w-full" : "w-5xl"} justify-between items-center mt-5 sm:mt-[40px] md:mt-2 `}>


        {/* left Aligned buttons */}

        {selectedTab === "mails" &&
          (isGmailAuthenticated || isOutlookAuthenticated) && (
            !selectedEmail && (
              <div className="absolute flex gap-2 left-0 -bottom-2 h-[28px} md:h-[28px] ">

                <MailBoxesIntegration
                  isOutlook={isOutlook}
                  setIsOutlook={setIsOutlook}
                  isGmailAuthenticated={isGmailAuthenticated}
                  isOutlookAuthenticated={isOutlookAuthenticated}

                />

                {/* Search Button */}
                {((isOutlook && isOutlookSynchronized) || (!isOutlook && isGmailSynchronized)) && (
                  <button
                    onClick={() => setIsSearchBoxOpen(!isSearchBoxOpen)}
                    className="p-2 text-white transition-all duration-200 border rounded-t-lg bg-zinc-800 border-zinc-700 br-1 hover:bg-zinc-700"
                  >
                    <FaSearch className="text-[10px] md:text-[15px]" />
                  </button>
                )}


                {/* Link Mail Boxes Button */}
                <button
                  onClick={() => setShowIntegration(true)}
                  className="flex items-center justify-center gap-2 p-2 text-white transition-all duration-200 border rounded-t-lg bg-zinc-800 border-zinc-700 br-1 hover:bg-zinc-700 group"
                >
                  <FiLink className="text-[10px] md:text-[15px]" />
                  <span className="hidden text-xs transition-all duration-300 group-hover:block ">Integrate Mail Boxes</span>
                </button>

              </div>
            )
          )}

        {selectedTab === "meeting" && (
          showPremium && (
            <div className="absolute left-0 flex gap-1 p-1 mx-auto text-sm border -bottom-2 bg-zinc-800 rounded-t-xl br-1 border-zinc-700 w-fit">
              {/* Completed Button */}
              <button
                title="Completed"
                className={`px-3 py-1  rounded-lg  hover:border-gray-300 hover:bg-zinc-700  text-white  transition-all duration-200 
                  ${meetingSubTab === "completed" ? "bg-primary-gradient" : ""}`}
                onClick={() => setMeetingSubTab("completed")}
              >
                Completed
              </button>

              {/* Upcoming Button */}
              <button
                title="Upcoming"
                className={`px-3 py-1 rounded-lg  hover:border-gray-300 hover:bg-zinc-700  text-white  transition-all duration-200 
                  ${meetingSubTab === "upcoming" ? "bg-primary-gradient" : ""}`}
                onClick={() => setMeetingSubTab("upcoming")}
              >
                Upcoming
              </button>
            </div>
          )
        )}


        {/* Centered Tab Buttons */}
        <div className="flex w-full opacity-0 pointer-events-none md:opacity-100 md:pointer-events-auto" style={{ fontSize: "0.6rem" }}>
          <div className="flex gap-1 p-1 py-2 mx-auto bg-transparent rounded-full w-fit">
          </div>
        </div>

        {/* Right-aligned buttons */}
        {selectedTab === "mails" &&
          (isGmailAuthenticated || isOutlookAuthenticated) && (
            !selectedEmail && (
              ((isOutlook && isOutlookSynchronized) || (!isOutlook && isGmailSynchronized)) && (
                <>
                  <div className="absolute right-0 items-center hidden gap-1 md:flex -bottom-[10px]">

                    <div className="flex gap-1 p-1 mx-auto text-sm border bg-zinc-800 border-zinc-700 rounded-t-xl br-1 w-fit">
                      {/* Inbox Button */}
                      <button
                        title="Inbox"
                        className={`px-1  rounded-lg  hover:border-gray-300 hover:bg-zinc-700  text-white  transition-all duration-200 
                  ${emailfilter["Inbox"] ? "bg-primary-gradient" : ""}`}
                        onClick={() => handleFilterChange("Inbox", "Inbox")}
                      >
                        <img src="/assets/inbox.png" alt="inbox" className="w-6" />
                      </button>

                      {/* Sent Button */}
                      <button
                        title="Sent Items"
                        className={`px-1  rounded-lg  hover:border-gray-300 hover:bg-zinc-700  text-white  transition-all duration-200 
                  ${emailfilter["SentItems"] ? "bg-primary-gradient" : ""}`}
                        onClick={() => handleFilterChange("SentItems", "SentItems")}
                      >
                        <img src="/assets/sent.png" alt="sent" className="w-6" />

                      </button>
                    </div>

                    <div
                      className="relative"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {/* compose an email Button */}
                      <button
                        onClick={() => {
                          setIsComposeEmailModalOpen(!isComposeEmailModalOpen);
                          setIsFilterModalOpen(false); // Close Filter modal
                          setIsSortingModalOpen(false); // Close Sorting modal
                          setIsAdvancedSearchOpen(false);
                        }}

                        className="p-2 text-white transition-all duration-200 border rounded-t-lg bg-zinc-800 border-zinc-700 br-1 hover:bg-zinc-700"
                      >
                        <RiMailAddFill className="text-[10px] md:text-[15px]" />
                      </button>

                      {/* compose an email Modal */}
                      {isComposeEmailModalOpen && (

                        <ComposeEmail
                          setIsComposeEmailModalOpen={setIsComposeEmailModalOpen}
                          message_id="12"
                          isOutlook={isOutlook}
                        />

                      )}

                    </div>


                    <div
                      className="relative inline-block"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {/* Filter Button */}
                      <button
                        onClick={() => setIsFilterModalOpen(!isFilterModalOpen)}
                        className="p-2 text-white transition-all duration-200 border rounded-t-lg bg-zinc-800 border-zinc-700 br-1 hover:bg-zinc-700"
                      >
                        <FaFilter className="text-[10px] md:text-[15px]" />
                      </button>

                      {/* Dropdown Modal */}
                      {isFilterModalOpen && (
                        <div className="absolute right-0 mt-2 transform   bg-zinc-800 p-4  border-[1px] border-gray-600 shadow-lg rounded-lg z-[60] ">
                          <EmailLabels
                            emailStats={emailStats}
                            emailfilter={emailfilter}
                            setEmailFilter={setEmailFilter}
                            handleFilterChange={handleFilterChange}
                          />
                        </div>
                      )}
                    </div>

                    <div
                      className="relative inline-block"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        onClick={() => setIsSortingModalOpen(!isSortingModalOpen)}
                        className="p-2 text-white transition-all duration-200 border rounded-t-lg bg-zinc-800 border-zinc-700 br-1 hover:bg-zinc-700">
                        <PiSortAscendingBold size={15} />
                      </button>

                      {/* Dropdown Modal */}
                      {isSortingModalOpen && (
                        <div className="absolute right-0  mt-2 transform   bg-zinc-900 p-4  border-[1px] border-gray-600 shadow-lg rounded-lg z-[60] ">
                          <EmailSorting
                            emailSorting={emailSorting}
                            setEmailSorting={setEmailSorting}
                            emailfilter={emailfilter}
                            setEmailFilter={setEmailFilter}
                          />
                        </div>
                      )}
                    </div>


                  </div>

                  <div className="absolute right-0 w-full md:hidden -bottom-2">
                    <div className="relative w-full">
                      <button
                        onClick={() => setIsMobileDrawerOpen(!isMobileDrawerOpen)}
                        className="absolute bottom-0 right-0 p-2 text-white border rounded-lg bg-zinc-800 border-zinc-600"
                      >

                        {isMobileDrawerOpen ? <IoClose size={10} /> : <TiThMenu size={10} />}
                      </button>


                      {/* Drawer with buttons (only on mobile) */}
                      {isMobileDrawerOpen && (
                        <div className="absolute right-0 z-50 flex mt-0 w-fit md:hidden">
                          <div className="relative flex flex-col items-center justify-around gap-2 p-2 border rounded-lg shadow-lg border-zinc-700 w-fit bg-zinc-900">
                            {/* Same buttons you have */}
                            <button
                              title="Inbox"
                              onClick={() => handleFilterChange("Inbox", "Inbox")}
                              className={`px-3 rounded-lg hover:bg-zinc-700 w-full text-white ${emailfilter["Inbox"] ? "bg-primary-gradient" : ""}`}
                            >
                              <img src="/assets/inbox.png" alt="inbox" className="w-5" />
                            </button>

                            <button
                              title="Sent"
                              onClick={() => handleFilterChange("SentItems", "SentItems")}
                              className={`px-3 rounded-lg hover:bg-zinc-700 text-white ${emailfilter["SentItems"] ? "bg-primary-gradient" : ""}`}
                            >
                              <img src="/assets/sent.png" alt="sent" className="w-5" />
                            </button>

                            <button
                              onClick={() => {
                                setIsComposeEmailModalOpen(!isComposeEmailModalOpen);
                                setIsmdFilterModalOpen(false);
                                setIsmdSortingModalOpen(false);
                                setIsAdvancedSearchOpen(false);
                              }}
                              className="p-2 text-white border rounded-lg bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <RiMailAddFill size={10} />
                            </button>

                            <button
                              onClick={() => setIsmdFilterModalOpen(!ismdFilterModalOpen)}
                              className="p-2 text-white border rounded-lg bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <FaFilter size={10} />
                            </button>

                            {/* Dropdown Modal */}
                            {ismdFilterModalOpen && (
                              <div className="absolute right-16 top-0  transform   bg-zinc-800 p-2 sm:p-4  border-[1px] border-gray-600 shadow-lg rounded-lg z-[60] ">
                                <EmailLabels
                                  emailStats={emailStats}
                                  emailfilter={emailfilter}
                                  setEmailFilter={setEmailFilter}
                                  handleFilterChange={handleFilterChange}
                                />
                              </div>
                            )}



                            <button
                              onClick={() => setIsmdSortingModalOpen(!ismdSortingModalOpen)}
                              className="p-2 text-white border rounded-lg bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <PiSortAscendingBold size={10} />
                            </button>

                            {/* Dropdown Modal */}
                            {ismdSortingModalOpen && (
                              <div className="absolute right-16 top-0 transform   bg-zinc-900 p-2 sm:p-4  border-[1px] border-gray-600 shadow-lg rounded-lg z-[60] ">
                                <EmailSorting
                                  emailSorting={emailSorting}
                                  setEmailSorting={setEmailSorting}
                                  emailfilter={emailfilter}
                                  setEmailFilter={setEmailFilter}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )}


                    </div>
                  </div>

                </>

              )
            )
          )}

      </div>
      <div className={` flex-1 ${!showPremium && "overflow-y-auto hide-sidebar"} `}>
        <div className="flex flex-col flex-1 h-full">

          {/* ################## TEAMS TAB ###############*/}
          {selectedTab === "teams" && (
            !showPremium ? (
              <PremiumFeatures
                setShowPremium={setShowPremium} />
            ) : (
              <div className="flex flex-col h-full gap-5 overflow-y-auto hide-sidebar">
                {dialogueData.map((item) => (
                  <div
                    key={item.id}
                    className="relative flex flex-col gap-2 px-4 py-3 transition-colors duration-150 ease-in-out border rounded-md br-2 bg-2 text-p-text"
                  >
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-1">
                        <div className="flex flex-shrink-0 rounded items-center justify-center w-6 h-6 p-0.5 bg-white">
                          <img src={item.app.image} alt="Trigger icon" />
                        </div>
                        <div className="flex flex-shrink-0 rounded-full items-center justify-center w-7 h-7 p-0.5 bg-white">
                          <img
                            src={item.app.userImage}
                            alt="Trigger icon"
                            className="rounded-full"
                          />
                        </div>
                      </div>
                      <strong className="flex-1 font-medium truncate text-md">
                        {item.app.userName}
                      </strong>
                      <div className="relative z-10 flex items-center gap-4 mb-3">
                        <button
                          type="button"
                          onClick={() => toggleDropdown(item.id)}
                          className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed -mr-1 py-1 px-1 border-0 bg-transparent flex items-center text-p-text"
                        >
                          <span className="sr-only">Open workflow settings</span>
                          <PiDotsThreeOutlineVerticalFill className="text-xl" />
                        </button>
                      </div>
                    </div>
                    {dropdownOpen === item.id && (
                      <div
                        className="absolute z-20 w-48 p-2 mt-8 border right-2 bg-1 br-1 rounded-xl text-s-text"
                        ref={walletAddressRef}
                      >
                        <button className="block w-full px-4 py-2 text-sm text-left bg-1-hover">
                          Share
                        </button>
                        <button className="block w-full px-4 py-2 text-sm text-left bg-1-hover">
                          Delete
                        </button>
                      </div>
                    )}
                    <div className="flex items-center justify-between">
                      <strong className="font-medium text-md">
                        {item.query || "No query provided"}
                      </strong>
                      <button
                        type="button"
                        onClick={() => toggleExpand(item.id)}
                        className={`rounded-[3px] text-md font-semibold ease-in-out disabled:cursor-not-allowed transform transition-all duration-300 px-4 text-xl ${expandedTile === item.id ? "rotate-180" : "rotate-0"
                          }`}
                      >
                        <IoIosArrowDown />
                      </button>
                    </div>

                    {/* LLM Answer */}
                    <p className="text-sm text-gray-600">
                      {item.answer || "No answer provided by LLM"}
                    </p>
                    <div className="flex items-center justify-between">
                      <div className="flex justify-center gap-2 mt-3">
                        {item.data_sources.map((source) => (
                          <div
                            key={source.id}
                            className="flex flex-shrink-0 rounded items-center justify-center w-8 h-8 p-0.5 bg-white"
                          >
                            <img src={source.image} alt="Trigger icon" />
                          </div>
                        ))}
                      </div>
                      <button className="px-3 py-1 rounded-lg bg-1">
                        Approve
                      </button>
                    </div>
                    {expandedTile === item.id ? (
                      <div className="mt-3">
                        {item.data_sources.length > 0 ? (
                          <div className="grid gap-2">
                            {item.data_sources.map((source, index) => (
                              <div
                                key={source.id}
                                className="flex flex-col items-start px-4 py-2 border rounded-lg br-1 bg-1"
                              >
                                <div className="flex items-center gap-2">
                                  <div className="flex flex-shrink-0 rounded items-center justify-center w-8 h-8 p-0.5 bg-white">
                                    <img src={source.image} alt="Trigger icon" />
                                  </div>
                                  <span className="font-semibold">
                                    {source.label}
                                  </span>
                                </div>
                                <div className="mt-3">
                                  <p className="text-sm text-zinc-400">
                                    {source.fileName} ·{" "}
                                    {taskDateFormat(source.timestamp)}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No data sources available</p>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ))}
              </div>
            )
          )}

          {/* ################## MAILS TAB ###############*/}
          {selectedTab === "mails" &&
            ((!isGmailAuthenticated && !isOutlookAuthenticated) ?
              <NoMailScreen
                noneAuthenticated={true}
                isGmailSynchronized
                isOutlookSynchronized
              />
              : (
                selectedEmail ? (
                  <EmailComponent
                    isOutlook={isOutlook}
                    messageId={selectedEmail.id}
                    analytics={analyticsData}
                    onClose={() => setSelectedEmail(null)}
                    isDialog={true}
                    isAnalyticsView={isAnalyticsView}
                    setIsAnalyticsView={setIsAnalyticsView}
                  />
                ) : (
                  <div className="flex flex-col h-full transition-all duration-300 ">
                    {/* Search input box with smooth transition */}
                    <div
                      // className={`transition-all duration-300 ${isSearchBoxOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0 hidden"
                      className={`transition-all duration-300 ${isSearchBoxOpen
                        ? "max-h-40 opacity-100 sticky top-0 z-10 bg-zinc-900"
                        : "max-h-0 opacity-0 hidden"

                        }`}
                    >
                      <EmailSearch
                        isSearchBoxOpen={isSearchBoxOpen}
                        setIsSearchBoxOpen={setIsSearchBoxOpen}
                        setIsAdvancedSearchOpen={setIsAdvancedSearchOpen}
                        isAdvanceSearchOpen={isAdvanceSearchOpen}
                        isOutlook={isOutlook}
                      />
                    </div>

                    {/* Email List - Will be pushed down smoothly */}
                    <EmailList
                      emailList={emails}
                      totalEmails={totalEmails}
                      emailsPerPage={emailsPerPage}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setSelectedEmail={setSelectedEmail}
                      loadingEmails={loadingEmails}
                      isOutlook={isOutlook}
                      emailfilter={emailfilter}
                      handleFilterChange={handleFilterChange}
                      className="w-full"
                      isGmailSynchronized={isGmailSynchronized}
                      isOutlookSynchronized={isOutlookSynchronized}
                    />
                  </div>
                )))
          }

          {/* ################## MEETING TAB ###############*/}
          {selectedTab === "meeting" && (
            !showPremium ? (
              <PremiumFeatures setShowPremium={setShowPremium} />
            ) : (

              <div className="flex flex-col items-center max-h-full gap-5 overflow-y-auto hide-sidebar">
                {meetingSubTab === "completed" && (
                  <>
                    {meetingFeedbackData.map((data, index) => <CombinedFeedback meetingData={data} key={index} />)}
                  </>
                )}

                {meetingSubTab === "upcoming" && (
                  <>

                    <CalendarEventEditor />

                  </>
                )}
              </div>
            )
          )}
        </div>
      </div>


      {/* Pagination controls */}
      {selectedTab === "mails" &&
        !selectedEmail && (
          (isGmailAuthenticated || isOutlookAuthenticated) && ((isOutlook && isOutlookSynchronized) || (!isOutlook && isGmailSynchronized)) && (
            <>
              <div className="flex items-center justify-between w-full gap-1 p-1 px-4 mx-auto text-zinc-200 bg-zinc-800 rounded-xl">
                {loadingEmails ? (
                  <div className="flex items-center justify-center w-full">
                    <div className="w-6 h-6 rounded-full bg-zinc-400 animate-pulse"></div>
                  </div>

                ) : (
                  <>
                    <button
                      onClick={prevPage}
                      disabled={currentPage === 1}
                      className={`px-2 py-1 rounded-lg ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:text-zinc-400"
                        }`}
                    >
                      <FaAngleLeft />
                    </button>
                    <span className="text-sm font-semibold">
                      Page {currentPage} of {totalPages === 0 ? "1" : totalPages}
                    </span>
                    <button
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                      className={`px-2 py-1 rounded-lg ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:text-zinc-400"
                        }`}
                    >
                      <FaAngleRight />
                    </button>
                  </>
                )}
              </div>
            </>
          )
        )}
    </>
  );
};

const Dialog = ({

}) => {
  const { userInfo } = DataState();
  const [openCreate, setOpenCreate] = useState(false);
  const [isAnalyticsView, setIsAnalyticsView] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isComposeEmailModalOpen, setIsComposeEmailModalOpen] = useState(false);
  const { isOutlook, refreshDialogKey } = useEmails();

  const openCreateModal = () => {
    switch (selectedTab) {
      case "mails":
        return setIsComposeEmailModalOpen(true);
      case "teams":
        return setOpenCreate(true);
      case "meeting":
        return setOpenCreate(true);
      default:
        return setOpenCreate(true);
    }

  };
  const closeCreateModal = () => {
    switch (selectedTab) {
      case "mails":
        return setIsComposeEmailModalOpen(false);
      case "teams":
        return setOpenCreate(false);
      case "meeting":
        return setOpenCreate(false);
      default:
        return setOpenCreate(false);
    }

  };
  const { emailStats, setEmailStats } = useEmails();
  const [input, setInput] = useState("");
  // const [emailStats, setEmailStats] = useState({});

  const [selectedTab, setSelectedTab] = useState("mails");
  const handleSelectTab = (tab) => {
    setSelectedTab(tab);
  };

  const getCreateName = () => {
    switch (selectedTab) {
      case "mails":
        return "New Email";
      case "teams":
        return "New Team";
      case "meeting":
        return "New Meeting";
      default:
        return "Create New";
    }
  };

  return (
    <BaseLayout
      createName={getCreateName()}
      handleCreate={openCreateModal}

      tabName="communication"
      leftSide={<></>}
    >
      {/* <div className="flex flex-col w-full h-full max-w-4xl gap-3 px-1 mx-auto"> */}
      <div className="flex flex-col w-full h-full gap-3 px-1 overflow-hidden ">
        {false ? (
          <div className="flex flex-col w-full h-full max-w-4xl gap-3 mx-auto">
            {userInfo && (
              <div className="flex items-center gap-2">
                <img
                  src={userInfo.picture}
                  className="object-cover w-8 h-8 rounded-full"
                />
                <span className="text-sm">{userInfo.name}</span>
              </div>
            )}
            <div className="flex flex-col items-center justify-center flex-1 gap-10">
              <div className="w-full">
                {/* <h1 className="text-5xl font-bold leading-snug">
                  <span className="mr-2 font-bold gradient-text">Namaste!</span>
                  I'm Oqlous AI
                  <br />
                  Let’s Me Automate your Communication and Response to Queries
                </h1> */}
                <OqlousCTA/>
                <h2 className="text-3xl text-zinc-500">Create your Dialogue</h2>
              </div>
            </div>
          </div>
        ) : (
          <DialogueDetails
            key={refreshDialogKey}
            setEmailStats={setEmailStats}
            handleSelectTab={handleSelectTab}
            selectedTab={selectedTab}
            isAnalyticsView={isAnalyticsView}
            setIsAnalyticsView={setIsAnalyticsView}
            emailStats={emailStats}
            selectedEmail={selectedEmail}
            setSelectedEmail={setSelectedEmail}
            isComposeEmailModalOpen={isComposeEmailModalOpen}
            setIsComposeEmailModalOpen={setIsComposeEmailModalOpen}
          />
        )}
      </div>
      <Modal
        title="Create Dialogue"
        isOpen={openCreate}
        onClose={closeCreateModal}
      >
        <CreateDialogueForm />
      </Modal>
      {isComposeEmailModalOpen && (

        <ComposeEmail
          setIsComposeEmailModalOpen={setIsComposeEmailModalOpen}
          message_id="12"
          isOutlook={isOutlook}
        />

      )}
    </BaseLayout>
  );
};

export default Dialog;